import { useSelector } from 'react-redux';

export const useFeaturesAutorization = () => {
    const userFeatures = useSelector(state => state.featureToggle.data.features);

    const userIsAuthorizedToUseFeature = feature => userFeatures[feature];

    return {
        userIsAuthorizedToUseFeature,
    };
};
